import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Country, Feature } from 'components/common/CommonTypes';
import { Countries, FeatureState } from 'Constants/Common';

export type Features = {
    Internationalization: Feature;
    GapClaim: Feature;
    UKTyreClaim: Feature;
    BankAccount: Feature;
    WheelDamage: Feature;
    CosmeticDamage: Feature;
    ActiveClaim: Feature;
};

export type SiteState = {
    brandId: number;
    brandStyles: string;
    brandSearchComplete: boolean;
    clientId: string;
    domain: string;
    audience: string;
    features: Features;
    language: string;
    country: Country;
    showBankDetails?: boolean;
    showRepairAddress?: boolean;
};

export const initialState: SiteState = {
    brandId: 0,
    brandStyles: '',
    brandSearchComplete: false,
    clientId: '',
    domain: '',
    audience: '',
    features: {
        Internationalization: FeatureState.Off,
        GapClaim: FeatureState.Off,
        UKTyreClaim: FeatureState.Off,
        BankAccount: FeatureState.Off,
        WheelDamage: FeatureState.Off,
        CosmeticDamage: FeatureState.Off,
        ActiveClaim: FeatureState.Off
    },
    language: 'en',
    country: Countries.Uk,
    showBankDetails: false,
    showRepairAddress: true
};

export const siteSlice = createSlice({
    name: 'site',
    initialState,
    reducers: {
        setSite: (_, action: PayloadAction<SiteState>) => action.payload,
        setBrandSearchComplete: (state, action: PayloadAction<boolean>) => {
            state.brandSearchComplete = action.payload;
        }
    }
});

export const { setSite, setBrandSearchComplete } = siteSlice.actions;
